export default {
  methods: {
    decimalFormatter(val) {
      return typeof val === "number" ? val.toFixed(2) : val;
    },
    booleanFormatter(val) {
      return val == 1 ? "Sim" : val == 0 ? "Não" : val;
    },
    percentageFormatter(val) {
      return val >= 1 ? '100%' : `${this.decimalFormatter(val * 100)}%`;
    },
  }
}
